/**
 * PJScrollLock — owner-aware body scroll-lock manager.
 *
 * Every overlay (cart drawer, lightbox, modals, menus) should lock page scroll
 * through this manager instead of toggling body classes directly. It tracks
 * WHO holds the lock so overlapping overlays can't unlock each other:
 *
 *   - First acquisition measures the scrollbar and applies .drawer-container
 *     (z_base.css: overflow hidden + padding-right compensation, so the page
 *     does not nudge sideways when the scrollbar disappears).
 *   - Nested acquisitions are no-ops; repeated acquisition by the same owner
 *     is idempotent (safe for re-render paths that call open() again).
 *   - The lock is released only when the LAST owner releases it.
 *
 * Callers should keep a fallback for robustness if this file failed to load:
 *   window.PJScrollLock ? PJScrollLock.lock("x") : document.body.classList.add("drawer-container")
 */
(function () {
  "use strict";

  var owners = new Set();

  function measureScrollbar() {
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      window.innerWidth - document.documentElement.clientWidth + "px"
    );
  }

  window.PJScrollLock = {
    lock: function (owner) {
      owner = owner || "anonymous";
      // Only measure while the scrollbar is still visible — measuring after
      // another overlay already locked would read 0 and wipe the compensation.
      if (
        owners.size === 0 &&
        !document.body.classList.contains("drawer-container")
      ) {
        measureScrollbar();
      }
      owners.add(owner);
      document.body.classList.add("drawer-container");
    },

    unlock: function (owner) {
      owners.delete(owner || "anonymous");
      if (owners.size === 0) {
        document.body.classList.remove("drawer-container");
      }
    },

    /** Force-release everything (theme editor section teardown). */
    reset: function () {
      owners.clear();
      document.body.classList.remove("drawer-container");
    },

    /** Debug/introspection. */
    holders: function () {
      return Array.from(owners);
    },
  };
})();
